import { render, staticRenderFns } from "./PortfolioGridCaptionWide.vue?vue&type=template&id=0c2bfabe&"
import script from "./PortfolioGridCaptionWide.vue?vue&type=script&lang=js&"
export * from "./PortfolioGridCaptionWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports